export enum AppActions {
  UNKNOWN = '',
  DELETE_FILE = 'File.Delete',
}
